var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<i class=\"selection-norecords\">"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"download_norecords",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":31},"end":{"line":1,"column":59}}}))
    + "</i>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/download/views/SelectionListViewEmpty.hbs
// module id = 2047
// module chunks = 0